<template>
  <div class="d-flex flex-column fill-height">
    <v-toolbar flat dense dark color="grey darken-4">
      <v-btn icon @click="closePinboard">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="font-weight-bold text-truncate pl-1"> Pinboard </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-switch v-model="showGlobalPins" label="Globale Pins" hide-details dense class="mt-0"></v-switch>
    </v-toolbar>

    <v-progress-linear indeterminate v-if="isPinboardLoading" color="primary"></v-progress-linear>

    <div class="chat-messages-container flex-grow-1 pa-4" ref="messagesContainer">
      <div v-if="!isPinboardLoading && filteredPins.length === 0" class="text-center grey--text pa-8">
        <v-icon size="60" color="grey darken-2">mdi-pin-off-outline</v-icon>
        <p class="mt-4 headline">Pinboard ist leer</p>
        <p class="body-1">Lange auf eine Nachricht drücken, um sie hier zu "Merken".</p>
      </div>

      <v-scroll-y-transition group>
        <div v-for="pin in filteredPins" :key="pin.key">
          <v-card class="mb-4" dark rounded="lg" color="grey darken-3">
            <v-card-text class="pa-2 pb-0 d-flex align-center caption grey--text">
              <v-icon v-if="pin.isGlobal" small class="mr-1">mdi-pin</v-icon>
              <v-icon v-else small class="mr-1">mdi-bookmark</v-icon>
              <span v-if="pin.isGlobal">
                Global von <strong>{{ pin.pinnedBy.vorname }}</strong>
              </span>
              <span v-else>Von <strong>Dir</strong> gemerkt</span>

              <v-spacer></v-spacer>

              <v-icon small class="mr-1">mdi-forum</v-icon>
              <span>{{ pin.group.name }}</span>
            </v-card-text>

            <v-divider class="my-1"></v-divider>
            <!-- 
            @click="$emit('jump-to-message', pin.originalPin)"
            -->
            <v-list-item three-line>
              <v-list-item-avatar class="mr-3">
                <v-img v-if="pin.sender.bild" :src="'/img/profilbilder/' + pin.sender.bild"></v-img>
                <span v-else>{{ getInitials(pin.sender) }}</span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{ pin.sender.vorname }} {{ pin.sender.nachname }}</v-list-item-title>
                <v-list-item-subtitle class="text-wrap" v-text="pin.content"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </div>
      </v-scroll-y-transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"

export default {
  name: "PinboardView",
  data() {
    return {
      showGlobalPins: true, // Der Filter-Schalter
    }
  },
  computed: {
    ...mapState("chatStore", ["pinboardPersonal", "pinboardGlobal", "isPinboardLoading"]),

    // NEU: Wandelt beide Listen in ein einheitliches Format um
    filteredPins() {
      const combined = []

      // 1. Persönliche Pins verarbeiten
      this.pinboardPersonal.forEach((msg) => {
        combined.push({
          key: `p-${msg._id}`,
          isGlobal: false,
          date: new Date(msg.createdAt),
          sender: msg.senderId || { vorname: "Unbekannt" },
          content: msg.textContent || (msg.fileInfo ? `Datei: ${msg.fileInfo.originalName}` : "Medium"),
          group: msg.groupId || { name: "Unbekannte Gruppe" },
          pinnedBy: null, // (Irrelevant)
          originalPin: msg, // (Für den Klick-Event)
        })
      })

      // 2. Globale Pins verarbeiten (nur wenn Filter aktiv)
      if (this.showGlobalPins) {
        this.pinboardGlobal.forEach((pin) => {
          if (!pin.messageId) return // (Sicherheitscheck)
          const msg = pin.messageId
          combined.push({
            key: `g-${msg._id}`,
            isGlobal: true,
            date: new Date(pin.createdAt), // Sortieren nach Pin-Datum
            sender: msg.senderId || { vorname: "Unbekannt" },
            content: msg.textContent || (msg.fileInfo ? `Datei: ${msg.fileInfo.originalName}` : "Medium"),
            group: pin.groupId || { name: "Unbekannte Gruppe" },
            pinnedBy: pin.pinnedBy || { vorname: "Admin" },
            originalPin: pin, // (Für den Klick-Event)
          })
        })
      }

      // 3. Nach Datum sortieren (neueste oben)
      return combined.sort((a, b) => b.date - a.date)
    },
  },
  methods: {
    ...mapActions("chatStore", ["setActiveGroup"]),
    closePinboard() {
      this.setActiveGroup(null)
    },
    getInitials(user) {
      if (!user) return "?"
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },
  },
  mounted() {
    // (Die Action zum Laden wird vom 'openPinboard' in chatStore aufgerufen)
  },
}
</script>

<style lang="scss" scoped>
/* (Kopier den .chat-messages-container Style aus chatMessageView) */
.chat-messages-container {
  overflow-y: auto;
  height: 0;
}
</style>
